// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = document.title+" - "+to.meta.title
  }
  next()
})

/*引入如下组件*/
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import VueAnalytics from 'vue-analytics'
Vue.use(ElementUI);
Vue.use(VueAnalytics, {
  id: 'UA-241296503-2',
  router
})

Vue.prototype.$axios= axios
axios.defaults.baseURL = '/api'  //关键代码

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js